<template>
  <div class="form-container block m-auto w-full mt-24">
    <h1 class="mb-4 text-2xl">Add New Role</h1>
    <form @submit.prevent="handleSubmit">
      <div class="p-2">
        <input
          ref="name"
          v-model="name"
          type="text"
          name="role name"
          class="w-full"
          placeholder="Enter role name"
          autocomplete="off"
        />
      </div>
      <div class="p-2 text-right">
        <button
          type="submit"
          class="border bg-green hover:bg-green-dark rounded-sm p-2 text-white text-shadow-none font-normal"
        >
          Add Role
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      name: "",
    }
  },
  mounted() {
    this.$refs.name.focus()
  },
  methods: {
    handleSubmit() {
      if (this.name) {
        this.axios({
          method: "post",
          url: `${siteConfig.siteURL}admin/roles`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
          data: { name: this.name },
        })
          .then(res => {
            if (res.data.status) {
              this.$noty.success(res.data.message)
            } else {
              this.$noty.error(res.data.message)
            }
          })
          .catch(err => {
            this.$noty.error(err)
            console.error(err)
          })
      }
    },
  },
}
</script>

<style scoped>
.form-container {
  min-width: 30rem;
  max-width: 40%;
}

button {
  text-shadow: none;
}
</style>
